module.exports = __webpack_public_path__ + "img/maui.47eb1ae6.jpg";